<template>
    <b-card
        class="mb-2"
        :sub-title="group.label"
    >
        <b-form-group
            v-for="(field, idx) in group.fields"
            v-bind:key="idx"   
        >
            <form-field
                :parent="group"
                :field="field"
                v-model="field.value"
            ></form-field>
        </b-form-group>
    </b-card>
</template>
<script>
import FormField from "./FormField"

export default {
    name        :   "form-group",
    props       :   [
                        "value",
                        "group"
                    ],
    data        ()  {
                        return {
                            input: {}
                        };
                    },
    methods     :   {
                        changeInput(value) {
                            
                        }
                    },
    watch       :   {
                        input(newValue, oldValue)   {
                                                        this.$emit("input", newValue);
                                                    }
                    },
    components  :   {
                        FormField
                    }
}
</script>